import {combineReducers} from "redux";
import saleReport from "./saleReport";
import dailyReport from "./dailyReport";
import dailyReportV1 from "./dailyReportV1";
import settlement from "./settlement";
import protest from "./protest";
import memberReport from './memberReport';
import oldBalance from './oldBalance';
import loan from './loan';
import totalReport from './totalReport';
import mainReport from "./mainReport";
import balance from "./balance";
import ticket from "./ticket";
import rebate from "./rebate";
import mixDailyReport from "./mixDailyReport";
import mixTotalReport from "./mixTotalReport";
import mixSettlement from "./mixSettlement";
import personalReport from "./personalReport";
import personalDailyReport from "./personalDailyReport";
import paperReport from "./paperReport";

const lotteryReportsReducer = combineReducers({
    saleReport,
    dailyReport,
    rebate,
    settlement,
    protest,
    memberReport,
    oldBalance,
    loan,
    totalReport,
    mainReport,
    balance,
    ticket,
    mixDailyReport,
    mixTotalReport,
    mixSettlement,
    dailyReportV1,
    personalReport,
    personalDailyReport,
    paperReport
});
export default lotteryReportsReducer;
